module.exports = __webpack_public_path__ + "static/media/elements-category.616e5cac.svg";